import { applyMiddleware, createStore, compose } from "redux";
import thunk from "redux-thunk";
import promise from "redux-promise-middleware";
import reducer from "./reducers/reducers";
import idleMonitor from "./idleMonitor";

let composeEnhancers = compose;

if (process.env.NODE_ENV !== "production") {
    if (window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__) {
        composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__;
    }
}

export default createStore(reducer, {}, composeEnhancers(
    applyMiddleware(promise(), thunk, idleMonitor)
));



// WEBPACK FOOTER //
// ./app/store.js